import {
  GetCategoryMaster,
  PostCategoryMaster,
  PutCategoryMaster,
} from '../apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

export interface InspectionCategoryParams {
  categoryId: string;
}

const endPoint = 'inspection-category';

export const getCategoryMaster = async (
  params?: InspectionCategoryParams,
): Promise<GetCategoryMaster> => {
  const queryParams = new URLSearchParams();

  if (params) {
    queryParams.append('categoryId', params.categoryId);
  }

  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const putCategoryMaster = async (
  newCategory: PutCategoryMaster,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(newCategory),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const postCategoryMaster = async (
  newCategory: PostCategoryMaster,
): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(newCategory),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const deleteCategoryMaster = async (
  params: InspectionCategoryParams,
): Promise<void> => {
  const queryParams = new URLSearchParams();
  queryParams.append('categoryId', params.categoryId);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'DELETE',
  });
  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
